import * as SelectStyle from "@omni/ui/components/Form/Select/select.style";
import { cn } from "@omni/utils/styles";
import { ComponentProps } from "react";
import { GroupBase } from "react-select";
import { default as ReactAsyncSelect } from "react-select/async";

type Props<
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
> = ComponentProps<typeof ReactAsyncSelect<Option, IsMulti, Group>> & {
    touched?: boolean;
    error?: boolean;
};

export const AsyncSelect = <
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    className,
    touched = false,
    error = false,
    ...props
}: Props<Option, IsMulti, Group>) => {
    return (
        <ReactAsyncSelect<Option, IsMulti, Group>
            {...props}
            className={cn(SelectStyle.select(), className)}
            classNames={{
                ...props.classNames,
                container: () =>
                    cn(SelectStyle.container({}), props.classNames?.container),
                control: ({ isFocused }) =>
                    cn(
                        SelectStyle.control({
                            isFocused: isFocused,
                            isInvalid: touched && error,
                            isValid: touched && !error
                        }),
                        props.classNames?.control
                    ),
                valueContainer: () =>
                    cn(
                        SelectStyle.valueContainer(),
                        props.classNames?.valueContainer
                    ),
                clearIndicator: () =>
                    cn(
                        SelectStyle.clearIndicator(),
                        props.classNames?.clearIndicator
                    ),
                loadingIndicator: () =>
                    cn(
                        SelectStyle.loadingIndicator(),
                        props.classNames?.loadingIndicator
                    ),
                dropdownIndicator: () =>
                    cn(
                        SelectStyle.dropdownIndicator(),
                        props.classNames?.dropdownIndicator
                    ),
                indicatorSeparator: () =>
                    cn(
                        SelectStyle.indicatorSeparator(),
                        props.classNames?.indicatorSeparator
                    ),
                option: ({ isSelected, isFocused }) =>
                    cn(
                        SelectStyle.option({
                            isSelected: isSelected,
                            isFocused: isFocused
                        }),
                        props.classNames?.option
                    ),
                input: () => "input-select",
                menuList: () =>
                    cn(SelectStyle.menuList(), props.classNames?.menuList)
            }}
        />
    );
};
